export default {
  am: {
    apiKey: 'AIzaSyD3Kv06xVZ7Ho3URAaKfPigAPGKNB_3KXs',
    authDomain: 'alchemy-machines-pilot.firebaseapp.com',
    projectId: 'alchemy-machines-pilot',
    storageBucket: 'alchemy-machines-pilot.appspot.com',
    messagingSenderId: '168734743785',
    appId: '1:168734743785:web:710ea3326d6f4e1f97a478',
  },
  tv: {
    apiKey: 'AIzaSyARBrmekFuKe1MaFGr4niYIRAriGd3c9Qg',
    authDomain: 'tv-pilot.firebaseapp.com',
    projectId: 'tv-pilot',
    storageBucket: 'tv-pilot.appspot.com',
    messagingSenderId: '105412570117',
    appId: '1:105412570117:web:68e2d79442a2e0fb47406c',
  }
}
